import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import img from "../../images/lead_profile.png";
import { useSelector } from "react-redux";
function SingleLeadProfileContent({ isSidebarOpen }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);
  const [visit, setVisit] = useState([]);
  const [quotationCreated, setQuotationCreated] = useState(false);
  const [visitCreated, setVisitCreated] = useState(false);
  const [followCreated, setFollowCreated] = useState(false);
  const [remarksCreated, setRemarksCreated] = useState(false);
  const [employeeunitsoldCreated, setemployeeunitsoldCreated] = useState(false);

  const adminuser = useSelector((state) => state.auth.user);
  const token = adminuser.token;

  const fetchLeads = async () => {
    try {
      const response = await axios.get(
        `https://crm-generalize.siarasystems.com/api/leads/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLeads(response.data);
      response.data.forEach((lead) => {
        console.log("Lead Quotation Status (raw):", lead.quotation);
      });

      const hasCreatedQuotation = response.data.some(
        (lead) =>
          lead.quotation && lead.quotation.trim().toLowerCase() === "created"
      );

      setQuotationCreated(hasCreatedQuotation);
    } catch (error) {
      console.error("Error fetching quotations:", error);
    }
  };

  const fetchFollowUp = async () => {
    try {
      const response = await axios.get(
        `https://crm-generalize.siarasystems.com/api/employe-follow-up-admin/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setFollowCreated(response.data[0]);
    } catch (error) {
      console.error("Error fetching quotations:", error);
    }
  };
  const fetchUnitSoldEmployee = async () => {
    try {
      const response = await axios.get(
        `https://crm-generalize.siarasystems.com/api/admin-unit-sold-lead-id/${leads[0].lead_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setemployeeunitsoldCreated(response.data[0]);
    } catch (error) {
      console.error("Error fetching quotations:", error);
    }
  };

  const fetchRemark = async () => {
    try {
      const response = await axios.get(
        `https://crm-generalize.siarasystems.com/api/remarks-admin/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response.data);
      setRemarksCreated(response.data[0]);
    } catch (error) {
      console.error("Error fetching remarks:", error);
    }
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const fetchVisit = async () => {
    try {
      const response = await axios.get(
        `https://crm-generalize.siarasystems.com/api/employe-visit-admin/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setVisit(response.data);
      const hasCreatedvisit = response.data.some(
        (lead) =>
          (lead.visit && lead.visit.trim().toLowerCase() === "fresh") ||
          "repeated"
      );
      setVisitCreated(hasCreatedvisit);
    } catch (error) {
      console.error("Error fetching quotations:", error);
    }
  };

  const handleViewQuotation = (lead) => {
    const name = lead.name;
    navigate(`/admin_view_quotations/${lead.lead_id}`);
  };
  const handleViewVisit = () => {
    navigate(`/admin_view_visit/${leads[0].lead_id}`);
  };
  const handleViewFollowUp = () => {
    navigate(`/admin_view_follow_up/${leads[0].lead_id}`);
  };
  const handleViewRemark = () => {
    navigate(`/admin_view_remark/${leads[0].lead_id}`);
  };
  const handleViewEmployeeUnitSold = () => {
    // navigate(`/admin_view_unit_sold/${leads[0].lead_id}`);
    navigate(`/view_unit_sold/general/${leads[0].lead_id}`)
  };

  useEffect(() => {
    fetchLeads();
    fetchFollowUp();
    fetchVisit();
    fetchRemark();
  }, [id]);

  useEffect(() => {
    if (leads.length > 0) {
      fetchUnitSoldEmployee();
    }
  }, [leads]);

  return (
    <>
      <div className="flex mt-20">
        <div className="w-[90%] sm:w-full min-h-screen bg-[#F9FAFF] p-2">
          <div className="container px-2 mx-auto p-4  ">
            <div className="sm:mt-2">
              <button
                onClick={() => navigate(-1)}
                className="bg-cyan-500 text-white px-3 py-1 max-sm:hidden rounded-lg hover:bg-cyan-600 transition-colors"
              >
                Back
              </button>
            </div>
            <h1 className="text-2xl text-center">Leads Profile</h1>
            <div className="mx-auto h-[3px] w-16 bg-cyan-600 my-3"></div>
            <div className="flex flex-wrap mb-4  mt-2 hidden sm:flex">
              <div className="w-full lg:w-1/3">
                <img src={img} alt="doctor-profile" className=" rounded-lg" />
              </div>
              {leads.map((lead, index) => (
                <div className="w-full lg:w-2/3 ">
                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                    <div>
                      <label className="text-cyan-600 font-semibold">
                        Name
                      </label>
                      <div className="p-2 bg-gray-100 rounded">
                        <p className="m-0 break-words">{lead.name}</p>
                      </div>
                    </div>

                    <div>
                      <label className="text-cyan-600 font-semibold">
                        Assigned To
                      </label>
                      <div className="p-2 bg-gray-100 rounded">
                        <p className="m-0">{lead.staff_name}</p>
                      </div>
                    </div>

                    <div>
                      <label className="text-cyan-600 font-semibold">
                        Mobile Number
                      </label>
                      <div className="p-2 bg-gray-100 rounded">
                        <p className="m-0">{lead.phone}</p>
                      </div>
                    </div>

                    <div>
                      <label className="text-cyan-600 font-semibold">
                        Lead Source
                      </label>
                      <div className="p-2 bg-gray-100 rounded">
                        <p className="m-0">{lead.leadSource}</p>
                      </div>
                    </div>

                    <div>
                      <label className="text-cyan-600 font-semibold">
                        Lead Status
                      </label>
                      <div className="p-2 bg-gray-100 rounded">
                        <p className="m-0">{lead.lead_status}</p>
                      </div>
                    </div>

                    <div>
                      <label className="text-cyan-600 font-semibold">
                        Assigned Date
                      </label>
                      <div className="p-2 bg-gray-100 rounded">
                        <p className="m-0">
                          {moment(lead.createdTime)
                            .format("DD MMM YYYY")
                            .toUpperCase()}
                        </p>
                      </div>
                    </div>

                    <div>
                      <label className="text-cyan-600 font-semibold">
                        Project Type
                      </label>
                      <div className="p-2 bg-gray-100 rounded">
                        <p className="m-0">{lead.project_type || "N/A"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className=" mt-2">
              <div className="">
                <div className="flex flex-wrap gap-2">
                  {/* Conditionally render the View Quotation button */}
                  {visitCreated ? (
                    <button
                      onClick={handleViewVisit}
                      className="bg-green-500 text-white px-4 py-2 w-full sm:w-auto rounded"
                    >
                      View Visit
                    </button>
                  ) : (
                    <p className="text-white bg-red-400 text-center px-4 py-2 w-full sm:w-auto rounded">
                      Visit not yet created
                    </p>
                  )}

                  {followCreated ? (
                    <button
                      onClick={handleViewFollowUp}
                      className="bg-yellow-500 text-white px-4 py-2 w-full sm:w-auto rounded"
                    >
                      View Follow Up
                    </button>
                  ) : (
                    <p className="text-white bg-red-400 text-center px-4 py-2 w-full sm:w-auto rounded">
                      Follow Up not yet created
                    </p>
                  )}
                  {remarksCreated ? (
                    <button
                      onClick={handleViewRemark}
                      className="bg-purple-500 text-white px-4 py-2 rounded w-full sm:w-auto"
                    >
                      View Remark
                    </button>
                  ) : (
                    <p className="text-white bg-red-400 text-center px-4 py-2 rounded w-full sm:w-auto">
                      Remark not yet created
                    </p>
                  )}
                  {employeeunitsoldCreated ? (
                    <button
                      onClick={handleViewEmployeeUnitSold}
                      className="bg-cyan-600 text-white px-4 py-2 rounded w-full sm:w-auto "
                    >
                      View Unit Sold
                    </button>
                  ) : (
                    <p className="text-white bg-red-400 text-center px-4 py-2 rounded w-full sm:w-auto">
                      Unit not yet sold
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div
              className={`overflow-x-auto mt-5 ${isSidebarOpen ? "w-[78rem]" : "sm:w-[85rem] w-auto"
                } `}
            >
              <table className="min-w-full whitespace-nowrap bg-white border">
                <thead>
                  <tr>
                    <th className="px-6 py-3 border-b-2 border-gray-300">
                      Assigned To
                    </th>
                    <th className="px-6 py-3 border-b-2 border-gray-300">
                      Name
                    </th>
                    <th className="px-6 py-3 border-b-2 border-gray-300">
                      Phone
                    </th>
                    <th className="px-6 py-3 border-b-2 border-gray-300">
                      Lead Source
                    </th>

                    {/* <th className="px-6 py-3 border-b-2 border-gray-300">
                      Assigned By
                    </th> */}
                    <th className="px-6 py-3 border-b-2 border-gray-300">
                      Lead Status
                    </th>
                    <th className="px-6 py-3 border-b-2 border-gray-300">
                      Address
                    </th>

                    <th className="px-6 py-3 border-b-2 border-gray-300">
                      Project
                    </th>
                    <th className="px-6 py-3 border-b-2 border-gray-300">
                      Project Type
                    </th>

                    <th className="px-6 py-3 border-b-2 border-gray-300">
                      Unit Type
                    </th>

                    <th className="px-6 py-3 border-b-2 border-gray-300">
                      Unit Number
                    </th>
                    <th className="px-6 py-3 border-b-2 border-gray-300">
                      Unit Status
                    </th>

                    <th className="px-6 py-3 border-b-2 border-gray-300">
                      Sold Date
                    </th>
                    <th className="px-6 py-3 border-b-2 border-gray-300">
                      Assigned Date
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {leads.map((lead, index) => (
                    <tr
                      key={lead.id}
                      className={index % 2 === 0 ? "bg-gray-100" : ""}
                    >
                      <td className="px-6 py-4 border-b border-gray-200 text-gray-800">
                        {lead.staff_name}
                      </td>
                      <td className="px-6 py-4 border-b border-gray-200 text-gray-800">
                        {lead.name}
                      </td>
                      <td className="px-6 py-4 border-b border-gray-200 text-gray-800">
                        {lead.phone}
                      </td>
                      <td className="px-6 py-4 border-b border-gray-200 text-gray-800">
                        {lead.leadSource}
                      </td>
                      {/* <td className="px-6 py-4 border-b border-gray-200 text-gray-800">
                        {lead.assignedBy}
                      </td> */}

                      <td className="px-6 py-4 border-b border-gray-200 text-gray-800">
                        {lead.lead_status}
                      </td>
                      <td className="px-6 py-4 border-b border-gray-200 text-gray-800">
                        {lead.address}
                      </td>

                      <td className="px-6 py-4 border-b border-gray-200 text-gray-800">
                        {lead.project_name}
                      </td>
                      <td className="px-6 py-4 border-b border-gray-200 text-gray-800">
                        {lead.project_type || "N/A"}
                      </td>
                      <td className="px-6 py-4 border-b border-gray-200 text-gray-800">
                        {lead.unit_type}
                      </td>
                      <td className="px-6 py-4 border-b border-gray-200 text-gray-800">
                        {lead.unit_number}
                      </td>

                      <td className="px-6 py-4 border-b border-gray-200 text-gray-800">
                        {lead.unit_status}
                      </td>
                      <td className="px-6 py-4 border-b border-gray-200 text-gray-800">
                        {lead.unit_updated_at?.split(" ")[0]}
                      </td>

                      <td className="px-6 py-4 border-b border-gray-200 text-gray-800">
                        {lead.createdTime}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SingleLeadProfileContent;
